const state = {
  addKfcDialog: false,
}

const mutations = {
  SET_addKfcDialog: (state, key) => {
    state.addKfcDialog = key
  },
}

const actions = {
  changeAppKey({ commit }, bool) {
    commit('SET_addKfcDialog', bool)
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/open.js